import { render, staticRenderFns } from "./UnlayerEmail.vue?vue&type=template&id=e4b7df7c"
import script from "./UnlayerEmail.vue?vue&type=script&lang=js"
export * from "./UnlayerEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports